import { AddinBookingOffCanvasTabEnum, BookingOffCanvasTabEnum } from '@jooxter/utils';
import { BookingOffCanvasState, FloorOffCanvasState, ResourceOffCanvasState } from './offcanvas.types';

export const defaultBookingState: BookingOffCanvasState = {
  mode: undefined,
  bookingId: undefined,
  resourceId: undefined,
  preset: undefined,
  directEdit: false,
  autoSelectFirstSlot: false,
  slotToBookInstantly: null,
  selectedIndex: BookingOffCanvasTabEnum.Planning,
  addinSelectedIndex: AddinBookingOffCanvasTabEnum.Information,
  previousView: undefined,
  planningDate: undefined,
};

export const defaultFloorState: FloorOffCanvasState = {
  mode: undefined,
  floorId: undefined,
  floorExceptionalClosingHoursId: undefined,
  preset: undefined,
  selectedBuilding: undefined,
};

export const defaultResourceState: ResourceOffCanvasState = {
  mode: undefined,
  resourceId: undefined,
  exceptionalOpeningHoursId: undefined,
  preset: undefined,
};
